export default class Utils {
    static getServer() {
        return 'https://api.ruurd.dev';
        return this.isLocal() ? 'http://localhost:3000' : 'https://api.ruurd.dev';
    }

    static isLocal() {
        return location.href.includes('localhost') ||
            location.href.includes('127.0.0.1') ||
            location.href.includes('192.168');
    }

    static bytesToReadable(bytes) {
        let length = Math.log10(bytes);
        if (length < 2) {
            return bytes + ' B';
        } else if (length < 5) {
            return (bytes / 1024).toFixed(2) + ' kB';
        } else if (length < 8) {
            return (bytes / (1024 ** 2)).toFixed(2) + ' MB';
        } else if (length < 12) {
            return (bytes / (1024 ** 3)).toFixed(2) + ' GB';
        } else if (length < 15) {
            return (bytes / (1024 ** 4)).toFixed(2) + ' TB';
        }
        return 'very bige bytes';
    }
}